import React from 'react'

const ThemeLoader = () => {
    return (
        <>
            <div className="themeLoader">
                <div className="kinetic"></div>
            </div>
        </>
    )
}

export default ThemeLoader